import { CapoPlugin } from "/app/50-ftd-20-frl-gllo/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];